export function SectionLabel({ children, light = false, "data-testid": testId }) {
  return (
    <div className="flex items-center gap-3 mb-4" data-testid={testId}>
      <span className="h-px w-8" style={{ background: "#D4AF37" }} />
      <span className={`eyebrow ${light ? "text-gold" : "text-gold"}`}>{children}</span>
    </div>
  );
}

export function Disclaimer({ compact = false, className = "" }) {
  return (
    <div
      data-testid="disclaimer-block"
      className={`text-xs leading-relaxed text-slate-500 border border-border rounded-md bg-subtle p-4 ${className}`}
    >
      <span className="font-semibold text-slate-700">Disclaimer: </span>
      KRV Prime provides educational and informational content relating to financial markets. Articles,
      research, examples, charts, strategies and tools are provided for educational purposes and should not be
      interpreted as personalised investment advice or a guarantee of financial performance. Markets involve risk,
      including possible loss of capital. Past performance does not guarantee future results.
      {!compact && " KRV Prime is not a SEBI Registered Investment Adviser or Research Analyst."}
    </div>
  );
}

export function DataStamp({ source, asOf, kind = "Educational/Derived Analysis" }) {
  const color = kind === "Live Data" ? "#16a34a" : kind === "End-of-Day" ? "#3B82F6" : "#D4AF37";
  return (
    <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-[11px] text-slate-500" data-testid="data-stamp">
      <span className="inline-flex items-center gap-1.5">
        <span className="h-1.5 w-1.5 rounded-full" style={{ background: color }} />
        {kind}
      </span>
      {source && <span>Source: {source}</span>}
      {asOf && <span>As of {asOf}</span>}
    </div>
  );
}
